import React from 'react'
import { FirebaseOptions, initializeApp } from 'firebase/app'
import { collection, initializeFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

import { getAuth } from 'firebase/auth'

import { candidateDataConverter } from './Converters'

import { FirebaseContext } from './FirebaseContext'

export const FirebaseProvider = ({ children, options }: { children: React.ReactNode; options: FirebaseOptions }) => {
  const app = initializeApp(options)
  const firestore = initializeFirestore(app, { ignoreUndefinedProperties: true })
  const auth = getAuth(app)
  const values = {
    app,
    firestore,
    auth,
    storage: getStorage(app),
    candidateCollection: collection(firestore, 'candidate').withConverter(candidateDataConverter),
  }

  return <FirebaseContext.Provider value={values}>{children}</FirebaseContext.Provider>
}
